import { ApplicationRoles } from '../../../constants/applicationRoles.ts';
import applicationRoutes from '../../../constants/applicationRoutes.ts';
import { RouteAuthenticationRequirement, RouteItem } from '@invara-dev/react-base';
import { ScrollLayout } from '../../../app/ScrollLayout.tsx';

export const ReportingNavItems: RouteItem = {
  text: 'Reporting',
  layout: <ScrollLayout />,
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [ApplicationRoles.staff],
  subItems: [
    {
      text: 'Activity Report',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      allowedRoles: [ApplicationRoles.staff],
      path: applicationRoutes.agent.activityReport,
      async lazy() {
        const component = await import('../../../features/activities/activityReport/activityReport.tsx');
        return { Component: component.default };
      }
    },
    {
      text: 'Booking Report',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: applicationRoutes.reporting.bookingReport,
      allowedRoles: [ApplicationRoles.crm, ApplicationRoles.accounting],
      async lazy() {
        const component = await import('../../../features/reporting/BookingReport.tsx');
        return { Component: component.default };
      }
    },
    {
      text: 'Checkout Report',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: applicationRoutes.reporting.checkoutReport,
      allowedRoles: [ApplicationRoles.crm, ApplicationRoles.accounting],
      async lazy() {
        const component = await import('../../../features/reporting/checkoutReport/CheckoutReport.tsx');
        return { Component: component.CheckoutReport };
      }
    },
    {
      text: 'Invoicing Group',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      allowedRoles: [ApplicationRoles.accounting],
      path: applicationRoutes.agent.invoiceGroup,
      async lazy() {
        const component = await import('../../../features/preRec/invoiceGroup/invoicingGroup.tsx');
        return { Component: component.default };
      }
    },

    {
      text: 'Issue Tracking Report',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: applicationRoutes.reporting.issueTrackingReport,
      allowedRoles: [ApplicationRoles.activityAdmin],
      async lazy() {
        const component = await import('../../../features/reporting/issueTrackingReport/IssueTrackingReport.tsx');
        return { Component: component.IssueTrackingReport };
      }
    }
  ]
};
